// Final social proof before completion
import FeedbackPage from '@/components/FeedbackPage'

export default function FinalTestimonialPage() {
  return (
    <FeedbackPage emoji="🚀" title="pages.onboarding.finalTestimonial.title" />
  )
}
